import useTiMaxStore from "./useTiMaxStore";
const useLoginInfo = () => {
  const loginInfo = useTiMaxStore((s) => s.loginInfo);
  return loginInfo;
};
useLoginInfo.getState = () => {
  return useTiMaxStore.getState().loginInfo;
};
var useLoginInfo_default = useLoginInfo;
export {
  useLoginInfo_default as default
};
